<template>
    <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow">
        <div class="split-content-downloads">
            <div class="header">
                <SmartLinkStandaloneElement :codename="typ.elements.icon.codename" v-if="data.icon">
                    <font-awesome class="icon" :icon="data.icon" />
                </SmartLinkStandaloneElement>
                <SmartLinkStandaloneElement :codename="typ.elements.title.codename">
                    <h2 class="title" v-if="data.title">
                        {{ data.title }}
                    </h2>
                </SmartLinkStandaloneElement>
            </div>
            <SmartLinkStandaloneElement v-if="!isEmpty(data.content)" :codename="typ.elements.content.codename">
                <div class="content">
                    <RichText :value="data.content" />
                </div>
            </SmartLinkStandaloneElement>
            <SmartLinkStandaloneElement :codename="typ.elements.documents.codename">
                <div class="document-list">
                    <Document v-for="doc in data.documents" :model="doc" />
                </div>
            </SmartLinkStandaloneElement>
        </div>
    </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import type { DocumentModel, SplitContentDownloadsModel } from '~/models';
import { contentTypes } from '~/models';
import { isEmpty } from '~/utils/kontent-helper'

const typ = contentTypes.split_content_downloads;

const props = defineProps<{ model: SplitContentDownloadsModel }>();

const pageStore = usePageStore();
const data = {
    title: props.model.elements.title.value,
    content: props.model.elements.content.value,
    icon: props.model.elements.icon.value,
    documents: pageStore.getListAs<DocumentModel>(props.model.elements.documents.value),
}
</script>
